<template>
  <div v-cloak @click="shutDown">
    <appheader index="2"></appheader>
    <div class="box_dingdan">
      <div class="box_title_dingdan_chakna">
        <div class="box_dingdan_chrlid">
          <div class="box_title">
            <h3 style="font-size: 28px; font-weight: 500; line-height: 33.6px">
              我的订单
            </h3>
          </div>
        </div>
        <div>
          <div>
            <el-input
              placeholder="搜索产品订单号"
              prefix-icon="el-icon-search"
              v-model="serchData"
              @keyup.enter.native="serarDingdan()"
              clearable
            ></el-input>
          </div>
          <div class="searchClass" @click="serarDingdan()">搜索</div>
        </div>
      </div>
      <!-- 订单列表 -->
      <div v-if="orderNoListFlag">
        <div
          v-for="(item, index) in CommodityList"
          :key="index"
          style="margin-bottom:12px;border:1px solid #ede2ce;"
        >
          <div class="spotOrderList_head">
            <div style="display:flex">
              <div style="margin:0 18px 0 10px">
                {{ item.createTime }}
              </div>
              <div style="margin-right:18px">
                <span>订单编号：</span>
                <span v-text="item.number"></span>
              </div>
              <!-- <div style="margin-right:18px">
              <span>网点编码：</span>
              <span v-text="item.network"></span>
            </div> -->
              <div
                style="display: flex;margin-right:18px"
                class="upDownTopClass"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item.networkName"
                  placement="top-start"
                >
                  <el-button
                    ><div style="display: flex;font-family: -webkit-body;">
                      <span style="display:block">网点名称：</span
                      ><span
                        v-text="item.networkName"
                        style="text-align: left;width:300px;overflow: hidden;white-space:nowrap;text-overflow: ellipsis;"
                      ></span></div
                  ></el-button>
                </el-tooltip>
              </div>
            </div>
            <div
              v-if="!item.showlist"
              class="orderUnfold"
              @click="orderUnfoldClick(item)"
              style="cursor:pointer"
            >
              <div>展开</div>
              <div>
                <img
                  src="../../Img/orderUnfold.png"
                  alt=""
                  style="margin-bottom: 2px;"
                />
              </div>
            </div>
            <div
              v-if="item.showlist"
              class="orderUnfold"
              @click="orderPutaway(item)"
              style="cursor:pointer"
            >
              <div>收起</div>
              <div style="margin-bottom: 4px;">
                <img
                  src="../../Img/orderPutaway.png"
                  alt=""
                  style="margin-bottom: 1px;"
                />
              </div>
            </div>
          </div>
          <div
            class="spotOrderList"
            v-if="item.showlist"
            style="position: relative;"
          >
            <div class="statusImg">
              <img
                src="../../Img/customMade.png"
                alt
                v-if="item.imgShow == false"
              />
              <img
                src="../../Img/spotImg.png"
                alt
                v-if="item.imgShow == true"
              />
            </div>
            <div
              v-for="(res, idx) in item.subOrderList"
              :key="idx"
              class="spotOrderList_body_data"
            >
              <div
                class="spotOrderList_body_img"
                @click.stop="enlargeImg(res, res[0].imgPath)"
              >
                <img :src="res[0].imgPath" alt="" />
              </div>
              <!-- 图片放大容器 -->
              <div class="pictureZoom" v-if="res.pictureZoomShow">
                <img :src="orderpictureZoom" alt="" />
              </div>
              <div
                style="display: flex;flex-direction: column;justify-content: center;margin-left: 15px;font-size:14px"
              >
                <div class="spotOrderList_body_child">
                  <div
                    class="spotOrderList_body_child_styleNumber"
                    style="width: 80px;"
                  >
                    款号
                  </div>
                  <div
                    class="spotOrderList_body_child_styleNumber"
                    style="width:72px"
                  >
                    品类
                  </div>
                  <div
                    class="spotOrderList_body_child_styleNumber"
                    style="width:100px"
                  >
                    材质
                  </div>
                  <div
                    class="spotOrderList_body_child_styleNumber"
                    style="width:65px"
                  >
                    分色
                  </div>
                  <div
                    class="spotOrderList_body_child_styleNumber"
                    style="width:95px"
                  >
                    金重范围
                  </div>
                  <div
                    class="spotOrderList_body_child_styleNumber"
                    style="width:110px"
                  >
                    价格范围
                  </div>
                  <div
                    class="spotOrderList_body_child_styleNumber"
                    style="width:90px"
                  >
                    尺寸
                  </div>
                  <div
                    class="spotOrderList_body_child_styleNumber"
                    style="width:55px"
                  >
                    扣子
                  </div>
                  <div
                    class="spotOrderList_body_child_styleNumber"
                    style="width:70px"
                  >
                    是否可调节
                  </div>
                  <div
                    class="spotOrderList_body_child_styleNumber"
                    style="width:80px;"
                  >
                    商品数量
                  </div>
                  <div
                    class="spotOrderList_body_child_styleNumber"
                    style="width:80px;"
                  >
                    下单数量
                  </div>
                  <div
                    class="spotOrderList_body_child_styleNumber"
                    style="width:100px;"
                  >
                    备注
                  </div>
                </div>
                <div v-for="(val, i) in res" :key="i">
                  <div class="spotOrderList_body_childTwo">
                    <div
                      class="spotOrderList_body_child_styleNumber colorClass"
                      style="width:80px"
                    >
                      {{ val.styleNumber }}
                    </div>
                    <div
                      v-if="!val.gender"
                      class="spotOrderList_body_child_styleNumber colorClass"
                      style="width:72px"
                    >
                      {{ val.category }}
                    </div>
                    <div
                      v-if="val.gender"
                      class="spotOrderList_body_child_styleNumber colorClass"
                      style="width:72px"
                    >
                      {{ val.category }}-{{ val.gender }}
                    </div>
                    <div
                      class="spotOrderList_body_child_styleNumber colorClass"
                      style="width:100px"
                    >
                      {{ val.texture }}
                    </div>
                    <div
                      class="spotOrderList_body_child_styleNumber colorClass"
                      style="width:65px"
                    >
                      {{ val.colorSeparation }}
                    </div>
                    <div
                      class="spotOrderList_body_child_styleNumber colorClass"
                      style="width:95px"
                    >
                      {{ val.goldWeightRange }}
                    </div>
                    <div
                      class="spotOrderList_body_child_styleNumber colorClass"
                      style="width:110px"
                    >
                      {{ val.priceRange | moneyFilter }}
                    </div>
                    <div
                      class="spotOrderList_body_child_styleNumber colorClass"
                      style="width:90px"
                    >
                      {{ val.size }}
                    </div>
                    <div
                      class="spotOrderList_body_child_styleNumber colorClass"
                      style="width:55px"
                    >
                      {{ val.button }}
                    </div>
                    <div
                      class="spotOrderList_body_child_styleNumber colorClass"
                      style="width:70px"
                    >
                      {{ val.adjustable }}
                    </div>
                    <div
                      class="spotOrderList_body_child_styleNumber colorClass"
                      style="width:80px"
                    >
                      {{ val.quantity }}
                    </div>
                    <div
                      class="spotOrderList_body_child_styleNumber colorClass"
                      style="width:80px"
                    >
                      {{ val.orderQuantity }}
                    </div>
                    <div
                      class="orderRemarkClass"
                      style="height:34px;line-height:34px;"
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="val.remark"
                        placement="bottom"
                      >
                        <el-button
                          ><div
                            class="spotOrderList_body_child_styleNumber colorClass"
                            style="width:100px;margin-top: 2px;display:inline-block;overflow: hidden;white-space:nowrap;text-overflow: ellipsis;text-align:center"
                          >
                            {{ val.remark }}
                          </div></el-button
                        >
                      </el-tooltip>
                    </div>
                    <div
                      v-if="item.imgShow == true"
                      style="position: relative;"
                      onclick="event.cancelBubble = true"
                    >
                      <div
                        style="color:#ff0000;margin-left:15px;width: 70px;text-align: center;height: 28px;line-height: 28px;color: #ec9368;font-size: 14px;border: 1px solid #ec9368;border-radius: 5px;cursor: pointer;"
                        @click.stop="getStockbottom(val, index, i)"
                      >
                        现货列表
                      </div>
                      <div v-if="val.spotShow == true" class="stockClass">
                        <div class="stockClass_title">现货列表</div>
                        <div class="spot_head">
                          <div class="spot_head_textuer">材质</div>
                          <div class="spot_head_name">主石名称</div>
                          <div class="spot_head_name">主石数量</div>
                          <div class="spot_head_name">主石重量</div>
                          <div class="spot_head_OneName">辅石1名称</div>
                          <div class="spot_head_OneName">辅石1数量</div>
                          <div class="spot_head_OneName">辅石1重量</div>
                          <div class="spot_head_OneName">辅石2名称</div>
                          <div class="spot_head_OneName">辅石2数量</div>
                          <div class="spot_head_OneName">辅石2重量</div>
                          <div class="spot_head_textuer">金重</div>
                          <div class="spot_head_textuer">净度</div>
                          <div class="spot_head_textuer">色度</div>
                          <div class="spot_head_name">标签价格</div>
                          <div class="spot_head_textuer">GIA</div>
                          <div class="spot_head_textuer">手寸</div>
                        </div>
                        <div
                          v-for="(item, idx) in stockList"
                          :key="idx"
                          class="spot_head"
                        >
                          <div class="spot_head_textuer colorClass">
                            {{ item.texture }}
                          </div>
                          <div class="spot_head_name colorClass">
                            {{ item.mainStoneName }}
                          </div>
                          <div class="spot_head_name colorClass">
                            {{ item.mainStoneNumber }}
                          </div>
                          <div class="spot_head_name colorClass">
                            {{ item.mainStoneWeight }}
                          </div>
                          <div class="spot_head_OneName colorClass">
                            {{ item.assistStoneNameOne }}
                          </div>
                          <div class="spot_head_OneName colorClass">
                            {{ item.assistStoneNumberOne }}
                          </div>
                          <div class="spot_head_OneName colorClass">
                            {{ item.assistStoneWeightOne }}
                          </div>
                          <div class="spot_head_OneName colorClass">
                            {{ item.assistStoneNameTwo }}
                          </div>
                          <div class="spot_head_OneName colorClass">
                            {{ item.assistStoneNumberTwo }}
                          </div>
                          <div class="spot_head_OneName colorClass">
                            {{ item.assistStoneWeightTwo }}
                          </div>
                          <div class="spot_head_textuer colorClass">
                            {{ item.goldWeight }}
                          </div>
                          <div class="spot_head_textuer colorClass">
                            {{ item.mainStoneClarity }}
                          </div>
                          <div class="spot_head_textuer colorClass">
                            {{ item.mainStoneColour }}
                          </div>
                          <div class="spot_head_name colorClass">
                            {{ item.labelPrice }}
                          </div>
                          <div class="spot_head_textuer colorClass">
                            {{ item.gia | giaFilter }}
                          </div>
                          <div class="spot_head_textuer colorClass">
                            {{ item.ringSize }}
                          </div>
                        </div>
                        <div class="pagingClass">
                          <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="spotTotal"
                            :page-size="spotPageSize"
                            @current-change="cartSpotListCurrentPage"
                          ></el-pagination>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="spotOrderList_Tail">
            <div style="display:flex;align-items:center;">
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.remark"
                placement="top"
              >
                <el-button
                  ><div style="display: flex">
                    <span style="display:block">【订单备注】</span
                    ><span
                      v-text="item.remark"
                      style=";width:750px;overflow: hidden;white-space:nowrap;text-overflow: ellipsis;color:#999999"
                    ></span></div
                ></el-button>
              </el-tooltip>
            </div>
            <div>
              <span>预估金额：</span>
              <span
                v-text="item.estimatedAmount"
                style="color:#FF2020;margin-right:20px"
              ></span>
            </div>
          </div>
        </div>
        <!-- 分页组件 -->
        <div class="box_fenye">
          <div style="display: inline-block">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-sizes="[10, 20, 40, 60, 100]"
              :page-size="pageSize"
              layout="total, prev, pager, next, sizes, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div v-if="!orderNoListFlag" style="margin: 159px 0;text-align: center;">
        <img src="../../Img/noData.png" alt="" />
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import $ from "jquery";
import Appheader from "../moudel/Appheader";
import bottom from "../bady_bottom/bottom";
export default {
  components: {
    Appheader,
    bottom,
  },
  data() {
    return {
      CommodityList: [],
      orderpictureZoom: "",
      spotListStatus: false,
      orderNoListFlag: true,
      orderSpotList: [],
      pageNum: 1,
      pageSize: 10,
      spotPageNum: 1,
      spotPageSize: 5,
      showImg: true,
      serchData: "",
      total: 0,
      spotTotal: 0,
      CommodityArr: [],
      documentNumber: "",
      subDocumentNumber: "",
      stockList: [],
      idName: "",
      idCart: "",
    };
  },
  mounted() {
    // 订单列表
    this.getCommodity();
  },
  beforeRouteLeave(to, from, next) {
    // 设置下一个路由的 meta
    to.meta.keepAlive = true; // C 跳转到 A 时让 A 不缓存，即刷新
    next();
  },
  methods: {
    // 购物车現貨分页按钮
    cartSpotListCurrentPage(pageNum) {
      var that = this;
      that.spotPageNum = pageNum;
      that.getStockList();
    },
    // 点击现货列表按钮
    getStockbottom(val) {
      if (val) {
        this.idName = val.id;
        this.idCart = val.orderId;
      }
      console.log(val);
      if (val.spotShow == false) {
        for (let k = 0; k < this.CommodityList.length; k++) {
          for (let j = 0; j < this.CommodityList[k].subOrderList.length; j++) {
            console.log("0000", this.CommodityList[k].subOrderList[j]);
            for (
              let h = 0;
              h < this.CommodityList[k].subOrderList[j].length;
              h++
            ) {
              this.CommodityList[k].subOrderList[j][h].spotShow = false;
            }
          }
        }
        val.spotShow = true;
        this.getStockList();
      } else {
        val.spotShow = false;
      }
      this.$forceUpdate();
    },
    // 关闭界面所有弹窗
    shutDown() {
      for (let k = 0; k < this.CommodityList.length; k++) {
        for (let j = 0; j < this.CommodityList[k].subOrderList.length; j++) {
          for (
            let h = 0;
            h < this.CommodityList[k].subOrderList[j].length;
            h++
          ) {
            this.CommodityList[k].subOrderList[j][h].spotShow = false;
          }
        }
      }
      this.$forceUpdate();
    },
    //现货列表
    getStockList() {
      var that = this;
      let url =
        "/direct/order/spot/paging?pageSize=" +
        that.spotPageSize +
        "&pageNum=" +
        that.spotPageNum;
      that
        .$axios({
          method: "POST",
          url: url,
          // async:false,
          cache: false,
          data: JSON.stringify({
            subOrderId: this.idName,
            orderId: this.idCart,
          }),
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json;charset=UTF-8",
            "T-token": JSON.parse(localStorage.getItem("userData")).token,
          },
        })
        .then((res) => {
          if (res.data.code == 0) {
            that.stockList = res.data.rows;
            that.spotTotal = res.data.total;
          }
        });
    },
    // 订单页图片放大
    enlargeImg(res, imgPath) {
      var that = this;
      if (res.pictureZoomShow != undefined) {
        if (res.pictureZoomShow == false) {
          for (let k = 0; k < that.CommodityList.length; k++) {
            for (let j = 0; j < that.CommodityList[k].orderList.length; j++) {
              that.CommodityList[k].orderList[j].pictureZoomShow = false;
            }
          }
          that.orderpictureZoom = imgPath;
          res.pictureZoomShow = true;
        } else {
          res.pictureZoomShow = false;
        }
      }

      that.$forceUpdate();
    },
    // 分页组件切换页数
    handleSizeChange(val) {
      // this.CommodityList=[]
      this.pageSize = val;
      this.getCommodity();
    },
    // 外层分页组件切换
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getCommodity();
    },
    serarDingdan() {
      this.getCommodity();
    },
    // 点击展开列表
    orderUnfoldClick(item) {
      item.showlist = true;
      this.$forceUpdate();
    },
    // 点击收起列表
    orderPutaway(item) {
      item.showlist = false;
      this.$forceUpdate();
    },
    // 订单列表接口
    getCommodity(e) {
      var that = this;
      var url =
        "/direct/order/paging?pageSize=" +
        this.pageSize +
        "&pageNum=" +
        this.pageNum;
      var data = {
        status: e ? e : "",
        number: that.serchData,
      };
      that
        .$axios({
          url: url,
          method: "post",
          cache: false,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            "T-token": JSON.parse(localStorage.getItem("userData")).token,
          },
          data: JSON.stringify(data),
        })
        .then((re) => {
          that.CommodityList = [];
          for (let i in re.data.rows) {
            re.data.rows[i].showlist = false;
            that.CommodityList.push(re.data.rows[i]);
          }
          console.log(that.CommodityList);
          if (that.CommodityList.length > 0) {
            that.orderNoListFlag = true;
          } else {
            that.orderNoListFlag = false;
          }
          for (let k = 0; k < that.CommodityList.length; k++) {
            var data = that.CommodityList[k].createTime.split("T");
            var dataTwo = data[1].split(".");
            that.CommodityList[k].createTime = [
              data[0] + "\xa0" + dataTwo[0],
            ][0];
            that.CommodityList[k].pictureZoomShow = false;
            for (
              let j = 0;
              j < that.CommodityList[k].subOrderList.length;
              j++
            ) {
              for (
                let d = 0;
                d < that.CommodityList[k].subOrderList[j].length;
                d++
              ) {
                that.CommodityList[k].subOrderList[j][d].spotShow = false;
                if (that.CommodityList[k].subOrderList[j][d].type == 1) {
                  that.CommodityList[k].imgShow = false;
                } else if (that.CommodityList[k].subOrderList[j][d].type == 2) {
                  that.CommodityList[k].imgShow = true;
                }
              }
            }
          }
          that.total = re.data.total;
        });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-pager li.active + li {
  border-left: none !important;
}
[v-cloak] {
  display: none;
}

.bottom_title {
  color: #ed9970;
}
.box_title_dingdan_chakna {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.orderSearch .el-input__inner {
  border-radius: 24px !important;
}
.box_title_dingdan_chakna div {
  display: inline-block;
  cursor: pointer;
}
.box_title_dingdan_chakna {
  padding-top: 20px;
  padding-bottom: 20px;
}
.box_title_dingdan_chakna ::v-deep .el-input__inner {
  border: 1px solid #ec9368;
  border-radius: 30px !important;
  height: 33px !important;
  line-height: 33px !important;
}
.box_title_dingdan_chakna ::v-deep .el-input__icon {
  height: 33px !important;
  line-height: 33px !important;
}
.box_dingdan {
  width: 1200px;
  margin: 0 auto;
  min-height: 600px;
}
.spotOrderList_head {
  display: flex;
  justify-content: space-between;
  background: #fff2ea;
  height: 52px;
  border-bottom: 1px solid #ede2ce;
  align-items: center;
}
.spotOrderList_Tail {
  display: flex;
  justify-content: space-between;
  height: 50px;
  align-items: center;
  background: #fffcfa;
}
.spotOrderList_body {
  display: flex;
  min-height: 105px;
}
.spotOrderList_body_child {
  display: flex;
  margin-top: 15px;
}
.spotOrderList_body_childTwo {
  display: flex;
  padding: 15px 0;
  flex-wrap: wrap;
  position: relative;
  border-bottom: 1px solid rgb(220, 223, 230);
  width: 1070px;
}
.spotOrderList_body_childTwo:last-child {
  border-bottom: none;
  padding-bottom: 15px;
}
.spotOrderList_body_child_styleNumber {
  display: flex;
  align-items: center;
  justify-content: center;
}
.colorClass {
  color: rgb(236, 147, 104);
}
.stockClass {
  width: 1200px;
  margin: 0 auto;
  margin-top: 5px;
  position: absolute;
  left: -1063px;
  box-sizing: border-box;
  z-index: 999;
  background: #fff;
  border: 1px solid rgb(236, 147, 104);
}
.stockClass_title {
  width: 100%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background: #f4c7b1;
  font-size: 18px;
  color: #000;
}
.pagingClass {
  display: flex;
  border-top: 1px solid #ec9368;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #ec9368;
  }
}
.spot_head {
  display: flex;
  border-top: 1px solid #ec9368;
  .spot_head_textuer {
    width: 70px;
    display: flex;
    justify-content: center;
    min-height: 40px;
    align-items: center;
    border-right: 1px solid #ec9368;
    box-sizing: content-box;
  }
  .spot_head_textuer:last-child {
    border-right: none;
  }
  .spot_head_name {
    min-height: 40px;
    width: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: content-box;
    border-right: 1px solid #ec9368;
  }
  .spot_head_OneName {
    min-height: 40px;
    border-right: 1px solid #ec9368;
    width: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: content-box;
  }
}
.spotOrderList_body_data {
  display: flex;
  min-height: 110px;
  border-bottom: 1px solid rgb(237, 226, 206);
  position: relative;
}
.spotOrderList_body_data:last-child {
  border-bottom: none;
  border-bottom: 1px solid #ede2ce;
}
.spotOrderList_body_img img {
  width: 92px;
  height: 92px;
}
.spotOrderList_body_img {
  display: flex;
  align-items: center;
  margin-left: 10px;
}
.orderUnfold img {
  margin-left: 5px;
}
.orderUnfold {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 36px;
}
.pictureZoom {
  width: 400px;
  height: 400px;
  position: fixed;
  transform: translate(-50%, -50%);
  top: 50%;
  z-index: 999;
  left: 50%;
}
.pictureZoom img {
  width: 400px !important;
  height: 400px !important;
}
.upDownTopClass .el-button {
  width: 380px;
  background: #fff2ea;
  border: none;
  font-size: 16px;
  padding: 0;
  text-align: left;
  color: #000;
  height: 21px;
  line-height: 21px;
}
.upDownTopClassStatus .el-button {
  width: 70px;
  background: #fff2ea;
  border: none;
  font-size: 17px;
  height: 21px;
  padding: 0;
  text-align: left;
  color: #000;
}
.spotOrderList_Tail .el-button {
  width: 750px;
  background: #fffcfa;
  border: none;
  font-size: 16px;
  padding: 0;
  text-align: left;
  color: #000 !important;
  font-family: -webkit-body;
}
.orderRemarkClass .el-button {
  background: #fff;
  border: none;
  font-size: 16px;
  padding: 0;
  text-align: center;
  margin-right: 8px;
  color: #000;
  width: 100px;
  height: 34px;
  line-height: 34px;
}
</style>
<style>
.orderSearch .el-input__inner {
  border-radius: 24px !important;
  border: 1px solid #ec9368 !important;
}

.box_dingdan_chrlid .el-input__inner {
  border: 1px solid #ec9368;
  border-radius: 0;
}
.demo-tabletable-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.box_fenye {
  width: 1200px;
  margin: 0 auto;
  margin-top: 68px;
  text-align: center;
  position: relative;
}
.box_fenye .el-pagination__total {
  line-height: 42px !important;
  color: #ec9368;
  font-size: 16px !important;
}
.box_fenye .el-pagination__jump {
  color: #ec9368;
  font-size: 16px;
}
.box_fenye .el-pagination__jump .el-input__inner {
  height: 42px !important;
  width: 40px;
}
.el-scrollbar__view .selected {
  color: #cdcdcd;
}
.el-scrollbar__view li {
  color: #ec9368;
}
.box_fenye .el-input__inner {
  width: 102px;
  height: 42px !important;
  border: 1px solid #cdcdcd;
  color: #ec9368;
  font-size: 16px !important;
}
.box_fenye .btn-next i::before {
  color: #ec9368;
  font-size: 16px;
  line-height: 42px;
}
.box_fenye .btn-prev i::before {
  color: #ec9368;
  font-size: 16px;
  line-height: 42px;
}
.box_fenye .active {
  color: #fff !important;
  background-color: #ec9368;
}
.box_fenye .el-pager li {
  color: #ec9368;
  width: 42px;
  height: 42px;
  line-height: 42px;
  font-size: 16px;
}
.box_fenye .el-pager li:hover {
  color: #fff;
  background-color: #ec9368;
}
.box_fenye .number {
  border: 1px solid #cdcdcd;
  margin: 0 2px;
}
.el-popper[x-placement^="top"]::-webkit-scrollbar {
  display: none !important;
}
.statusImg {
  width: 40px;
  height: 40px;
  position: absolute;
  right: 0;
  top: 0;
}
.statusImg img {
  width: 40px;
  height: 40px;
}
</style>
